import { GrantsType, hasScopedPermission } from '../../Shared/utils/auth';

export const deletePartner = (grants: GrantsType) =>
  hasScopedPermission(grants, 'system', 'partners.delete');
